import React from 'react'
import {
    FormControl, InputAdornment, TextField,
} from '@material-ui/core';
import useWithPercentageValue from "./useWithPercentageValue";
import _ from "lodash";

const WithPercentageInput = ({name, amountValue, percentageValue, handleOnChange, Container = null, ...props}) => {
    const percentageLabel = _.startCase(`change_${name}`);
    const percentageName = `percentage_change_${name}`;
    const {value, setValue, percentage, setPercentage} = useWithPercentageValue(amountValue, percentageValue);

    return (<React.Fragment>

        {
            Container ? Container(<FormControl fullWidth>
                <TextField
                    label={_.startCase(name)}
                    variant="outlined"
                    name={name}
                    inputProps={{maxLength: 40}}
                    type='number'
                    value={value}
                    onChange={(event) => setValue(event.target.value)}
                    onBlur={handleOnChange}
                />
            </FormControl>) : <FormControl fullWidth>
                <TextField
                    label={_.startCase(name)}
                    variant="outlined"
                    name={name}
                    inputProps={{maxLength: 40}}
                    type='number'
                    value={value}
                    onChange={(event) => setValue(event.target.value)}
                    onBlur={handleOnChange}
                />
            </FormControl>
        }

        {
            Container ? Container(<FormControl fullWidth>
                <TextField
                    label={percentageLabel}
                    variant="outlined"
                    name={percentageName}
                    inputProps={{
                        maxLength: 40
                    }}
                    InputProps={{
                        endAdornment: <InputAdornment position="end">%</InputAdornment>
                    }}
                    type='number'
                    value={percentage}
                    onChange={(event) => setPercentage(event.target.value)}
                    onBlur={handleOnChange}
                />
            </FormControl>) : <FormControl fullWidth>
                <TextField
                    label={percentageLabel}
                    variant="outlined"
                    name={percentageName}
                    inputProps={{
                        maxLength: 40
                    }}
                    InputProps={{
                        endAdornment: <InputAdornment position="end">%</InputAdornment>
                    }}
                    type='number'
                    value={percentage}
                    onChange={(event) => setPercentage(event.target.value)}
                    onBlur={handleOnChange}
                />
            </FormControl>
        }
    </React.Fragment>)
}

export default WithPercentageInput;